import React from 'react';
import BaseModal from 'Modals/BaseModal';
import connectModal from 'Modals/enhancers/ConnectModal';
import ModalTypeEnum from 'Modals/ModalConstants';
import UploadDocumentBodyContent from 'Modals/content/UploadDocumentBodyContent';

const FreeWriteDocumentUploadModalReadyContainer = connectModal(
  BaseModal,
  'freewriteUploadReadyModal',
  {
    modalType: ModalTypeEnum.FREE_WRITE_UPLOAD_READY,
    modalClass: 'modal template-upload-modal',
    bodyContent: <UploadDocumentBodyContent />,
    includeHeaderCloseButton: true,
    isDynamicContent: true,
  },
);

export default FreeWriteDocumentUploadModalReadyContainer;



// WEBPACK FOOTER //
// ./src-react/Modals/containers/FreeWriteDocumentUploadReadyModal/index.jsx